import { Controller } from "@hotwired/stimulus"

/**
 * Checkbox Button Controller with Dynamic Label
 *
 * Enables/disables button based on checkbox selection and updates button label
 * to show the count of selected items.
 *
 * @example
 * <div data-controller="checkbox-button"
 *      data-checkbox-button-label-value="Delete items">
 *   <input type="checkbox"
 *          data-checkbox-button-target="checkbox"
 *          data-action="change->checkbox-button#update">
 *   <input type="checkbox"
 *          data-checkbox-button-target="checkbox"
 *          data-action="change->checkbox-button#update">
 *   <button data-checkbox-button-target="button">
 *     <span>Delete items</span>
 *   </button>
 * </div>
 *
 * Results in:
 * - 0 selected: <span>Delete items</span> (disabled)
 * - 1+ selected: <span>Delete items</span><span class='button-secondary--badge'>1</span> (enabled)
 */

export default class extends Controller {
  static targets = ["checkbox", "button", "downloadButton", "label", "badge"]

  static values = {
    label: String,
    labelAll: String,
    total: { type: Number, default: 0 },
    selectAll: { type: Boolean, default: false }
  }

  connect() {
    this.update()
  }

  enableSelectAll() {
    this.selectAllValue = true
    this.update()
  }

  disableSelectAll() {
    this.selectAllValue = false
    this.update()
  }
  update() {
    const checkedCount = this.checkboxTargets.filter(c => c.checked).length
    const displayCount = checkedCount === 0 ? this.totalValue : checkedCount

    this.labelTargets.forEach(label => {
      label.textContent = checkedCount === 0
        ? this.labelAllValue
        : this.labelValue
    })

    this.badgeTargets.forEach(badge => {
      badge.textContent = `(${displayCount})`
    })

    this.buttonTargets.forEach(button => {
      const label = checkedCount === 0 ? this.labelAllValue : this.labelValue
      button.textContent = `${label} (${displayCount})`
    })
  }
}
